module.exports = __webpack_public_path__ + "static/media/logo.9f7e506d.svg";